<template>
  <v-flex xs12 class="mb-4">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <layout-no-padding>
            <page-title :routeProps="routeProps"></page-title>
          </layout-no-padding>

          <div class="vertical-center-container text-xs-right">
            <v-tooltip left>
              <v-btn
                slot="activator"
                icon
                large
                flat
                :color="$store.state.global.pages.billing.color"
                @click="importDialog = true"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>Import Approved Bill Lines
            </v-tooltip>
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-container fluid>
        <v-layout>
          <v-flex xs12 sm6 lg3>
            <div class="flex-container-space-between">
              <v-autocomplete
                label="Choose filter"
                :items="filterCols"
                v-model="filterCol"
                prepend-icon="list"
                :clearable="true"
              ></v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-text-field
              label="Filter by..."
              v-model="filterBy"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <div class="flex-container-space-between">
          <div></div>
          <div class="text-xs-right grey--text body-2">
            <chip-display></chip-display>
          </div>
        </div>
        <card-divider-full></card-divider-full>
      </div>

      <v-card-actions></v-card-actions>
    </v-card>

    <v-dialog v-model="importDialog" lazy max-width="700px">
      <import-approved-bill-lines @close="importDialog = false" title="Import Approved Bill Lines"></import-approved-bill-lines>
    </v-dialog>

    <filter-drawer></filter-drawer>
    <docket-add-wrapper v-model="addDocketDialog"></docket-add-wrapper>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketAddWrapper from '@/components/addDocket/wrapper'
import FilterDrawer from '@/components/trips/filterDrawer'
import RouteProps from '@/services/mixins/routeProps'
import BillingPeriods from '@/services/mixins/billingPeriods'

import { addDays } from 'date-fns'
import FormatDates from '@/services/mixins/formatDates'
import DateRangeOptions from '@/services/mixins/dateRangeOptions'
import VDateRange from '@/components/ui/vDateRange'
import ImportApprovedBillLines from '@/modules/approvedBillLines/importApprovedBillLines'
import ChipDisplay from '@/components/ui/chipDisplay'
export default {
  mixins: [RouteProps, FormatDates, DateRangeOptions, BillingPeriods],
  components: {
    DocketAddWrapper,
    VDateRange,
    FilterDrawer,
    ChipDisplay,
    ImportApprovedBillLines
  },
  data() {
    return {
      snackbarText: '',
      snackbarColor: 'blue',
      showSnackbar: false,
      addDocketDialog: false,
      importDialog: false,
      filterCols: [
        {
          value: 'project.name',
          text: 'Project'
        },
        {
          value: 'contractor.name',
          text: 'Sub-contractor'
        },
        {
          value: 'user.email',
          text: 'Entered By'
        },
        {
          value: 'abn',
          text: 'ABN'
        },
        {
          value: 'externalRef',
          text: 'Reference'
        },
        {
          value: 'notes',
          text: 'Notes'
        }
      ],
      dateRangeOptions: {
        startDate: '2019-01-03',
        endDate: '2019-02-02',
        format: 'DD/MM/YYYY',
        maxDate: this.makeComputerDate(addDays(new Date(), 30)),
        presets: [
          {
            label: 'Today',
            range: [
              this.makeComputerDate(new Date()), //start date. YYYY-MM-DD
              this.makeComputerDate(new Date()) // end date. YYYY-MM-DD
            ]
          },
          {
            label: 'Last 15 days',
            range: [
              this.makeComputerDate(addDays(new Date(), -15)), //start date. YYYY-MM-DD
              this.makeComputerDate(new Date()) // end date. YYYY-MM-DD
            ]
          },
          {
            label: 'Last 30 days + Next 30 days',
            range: [
              this.makeComputerDate(addDays(new Date(), -30)), //start date. YYYY-MM-DD
              this.makeComputerDate(addDays(new Date(), 30))
            ]
          }
        ]
      },
      dateRangeMenu: false
    }
  },
  computed: {
    filterCol: Store.getSet({ store: 'bills', prop: 'filterCol' }),
    filterBy: Store.getSet({ store: 'approvedBillLines', prop: 'filterBy' }),
    dates: Store.getSet({ store: 'bills', prop: 'dates' }),
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    drawer: Store.getSet({ store: 'shared', prop: 'drawer' }),
    showCreated: Store.getSet({ store: 'shared', prop: 'showCreated' })
  },
  mounted() {
    this.dates = [
      this.makeComputerDate(addDays(new Date(), -15)), //start date. YYYY-MM-DD
      this.makeComputerDate(new Date()) // end date. YYYY-MM-DD
    ]
  },
  methods: {
    toggleView() {
      this.listView = !this.listView
    }
  }
}
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>
